import styles from './styles/dashboard.module.css';

import ChartOverview from './ChartOverview';
import CommonOverview from './CommonOverview';
import Dropdown from './Dropdown';

export default function Dashboard({ commonResponse, commonError, commonLoading, handleChange, reloadCommon }) {
    const commonItems = [
        { id: 1, key: 'sameTimeAccess', title: '현재 접속자' },
        { id: 2, key: 'usageOverview', title: '문서 검색' },
        { id: 3, key: 'positiveFeedback', title: '만족 피드백' },
        { id: 4, key: 'negativeFeedback', title: '불만족 피드백' }
    ];

    const chartItems = [
        { id: 1, key: 'teamOverview', title: '팀별 사용 현황', handleReload: reloadCommon },
        { id: 2, key: 'categoryOverview', title: '카테고리별 사용 현황', handleReload: null }
    ];

    return (
        <div className={styles.grandWrapper}>
            <div className={styles.wrapper}>
                <div className={styles.containerTitle}>
                    <p>대시보드</p>
                    <Dropdown handleChange={handleChange} />    
                </div>

                <div className={styles.containerCommon}>
                    {commonLoading &&
                        <>
                            {Array.from({ length: 4 }).map((_, index) => (
                                <CommonOverview key={index} loading={true} />
                            ))}
                        </>
                    }

                    {!commonLoading && commonResponse &&
                        commonItems.map((item) => {
                            const { id, key, title } = item;                            
                            return (
                                <CommonOverview
                                    key={id}
                                    title={title}
                                    data={commonResponse[key]}
                                    loading={false}
                                />
                            );
                        })
                    }

                    {!commonLoading && commonError &&
                        <>
                            {Array.from({ length: 4 }).map((_, index) => (
                                <CommonOverview key={index} error={commonError} loading={false} />
                            ))}
                        </>
                    }
                </div>

                {chartItems.map((item) => {
                    const { id, key, title, handleReload } = item;
                    return (
                        <ChartOverview 
                            key={id}
                            title={title} 
                            data={!commonLoading && commonResponse ? commonResponse[key] : null}
                            error={!commonLoading && commonError ? commonError : null}
                            loading={commonLoading}
                            handleReload={handleReload}
                        />
                    );
                })}
            </div>
        </div>
    );
}
